import React from "react";
import RecurrentExpensesContainer from "../../containers/RecurrentExpenses";

function RecurrentExpenses(props) {
  return <RecurrentExpensesContainer {...props} />;
}

export default RecurrentExpenses;
